import React, { useState, useEffect, useRef } from 'react';
import { 
  Container, 
  Dropdown, 
  Table, 
  Pagination,
  Form,
  Navbar,
  Nav
} from 'react-bootstrap';
import './ApplicationsPage.css';

import { getRequestsList } from './actions';
import { requestword } from '../../components/helpers/wordsnumber';

const tableInfo = { 
  headers: [
    "Ім'я дитини",
    "Свідотство",
    "Подано",
    "Надсилати з",
    "Статус",
    ""
  ], 
  fields: [ 
    "name", 
    "certificate", 
    "submitted", 
    "sendFrom", 
    "status",
    "owner"
  ] 
};


const list_filters = [
  {field:"filter_selected_zdo", label:"Тільки з обраними закладами", sh_label: "Обрані ЗДО"},
  {field:"filter_benefits", label:"Тільки пільгові", sh_label: "Пільгові"},
  {field:"filter_owner", label:"Мої заявки", sh_label: "Мої"},
]

const ApplicationsPage = () => {
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [applicationsData, setApplicationsData] = useState([]);
  const [allcount, setAllCount] = useState(0);
  const [isLoad, setLoad] = useState(false);
  const [sort, setSort] = useState({sortBy: "submitted", directBy: "down"});
  const [activeFilters, setActiveFilters] = useState({
    filter_selected_zdo: false,
    filter_benefits: false,
    filter_owner: false
  });

  const timeoutRef = useRef(null);

  const updSort = (i) => {
    const direction = tableInfo.fields[i] !== sort.sortBy ? sort.directBy : sort.directBy == "down" ? "up" : "down";
    setSort({sortBy: tableInfo.fields[i], directBy: direction });
  }

  const updData = async () => {
    if(isLoad) return;
    setLoad(true);

    const {all_count, data } = await getRequestsList({
      search, 
      page, 
      pageSize, 
      sortBy: sort.sortBy, 
      sortDirection: sort.directBy,
      filters: activeFilters
    });

    setApplicationsData(data);
    setAllCount(all_count);
    setLoad(false);
  }

  const handleChange = (e) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setPage(0);
      setSearch(e.target.value);
    }, 500);
  };

  // Функція для перемикання фільтрів
  const toggleFilter = (filterName) => {
    setActiveFilters(prev => ({
      ...prev,
      [filterName]: !prev[filterName]
    }));
    setPage(0); // Скидаємо на першу сторінку при зміні фільтра
  };

  // Функція для скидання всіх фільтрів
  const clearAllFilters = () => {
    setActiveFilters({
      filter_selected_zdo: false,
      filter_benefits: false,
      filter_owner: false
    });
    setPage(0);
  };

  // Отримання тексту для кнопки фільтрів
  const getFilterButtonText = () => {
    const activeFilterCount = Object.values(activeFilters).filter(Boolean).length;
    
    if (activeFilterCount === 0) {
      return "Фільтри не застосовані";
    }
    
    const activeFilterNames = [];
    if (activeFilters.filter_selected_zdo) {
      activeFilterNames.push("Обрані ЗДО");
    }
    if (activeFilters.filter_benefits) {
      activeFilterNames.push("Пільгові");
    }
    if (activeFilters.filter_owner) {
      activeFilterNames.push("Мої заявки")
    }
    
    return `Застосовано: ${activeFilterNames.join(", ")}`;
  };

  useEffect(() => { 
    updData(); 
  }, [page, search, pageSize, sort, activeFilters]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const ArrPage = Array.from({length: Math.ceil(allcount/pageSize) }, (_, i) => i);

  return (
    <div className="applications-page">
      <main className="main-content">
        <Container>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1 className="mb-3">Всі заявки</h1>
              <p className="text-muted">Тут ви можете знайти інформацію про подані заявки та їх статуси</p>
            </div>
          </div>

          {/* Controls */}
          <div className="d-flex justify-content-between align-items-center mb-4 applications-controls">
            <Dropdown>
              <Dropdown.Toggle variant="outline-secondary" className="filter-btn">
                {getFilterButtonText()}
              </Dropdown.Toggle>
              <Dropdown.Menu className="applications-filter-menu">
                {list_filters.map(f=>
                  <Dropdown.Item 
                    as="button"
                    className={`filter-item ${activeFilters[f.field] ? 'active' : ''}`}
                    onClick={() => toggleFilter(f.field)}
                  >
                    <div className="filter-checkbox">
                      {activeFilters[f.field] && (
                        <span className="filter-checkmark">✓</span>
                      )}
                    </div>
                    {f.label}
                  </Dropdown.Item>
                )}
                                
                <Dropdown.Divider />
                
                <Dropdown.Item 
                  as="button"
                  className="filter-clear"
                  onClick={clearAllFilters}
                >
                  Скинути всі фільтри
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <div className="search-box">
              <i className="fas fa-search search-icon"></i>
              <Form.Control 
                type="text" 
                placeholder="Пошук заявок..." 
                className="applications-search"
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <Table className="applications-table">
              <thead className="table-header">
                <tr>
                 {tableInfo.headers.map((lab, i) => (
                   <th key={i} onClick={() => updSort(i)}>
                     {lab}
                   </th>
                 ))}
                </tr>
              </thead>
              <tbody>
                {applicationsData.map((application) => (
                  <tr key={application.id}>
                    <td>
                      <a href="#" className="child-name-link">{application.name}</a>
                    </td>
                    <td>{application.certificate}</td>
                    <td>{application.submitted}</td>
                    <td>{application.sendFrom}</td>
                    <td>
                      <span className={`status ${application.statusClass}`}>
                        {application.status}
                      </span>
                    </td>
                    <td className={application.note ? 'text-muted' : ''}>
                      {application.note}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Pagination */}
          <div className="d-flex align-items-center mt-4 pagination-wrapper">
            <div className="pagination-info">Всього {allcount} {requestword(allcount)}</div>
            { ( ArrPage.length > 1 ) &&  (
              <Pagination className="applications-pagination">
                <Pagination.Prev onClick={page > 0 ? () => setPage(page - 1) : () => {}}>
                  <span aria-hidden="true">&lt;</span>
                </Pagination.Prev>
                { ArrPage.slice(page - (page % 5), page + (5 - page % 5)).map((v) => (
                  <Pagination.Item 
                    key={v} 
                    active={v === page} 
                    onClick={() => setPage(v)}
                  >
                    {v + 1}
                  </Pagination.Item>
                )) }
                <Pagination.Next onClick={page < ArrPage.length ? () => setPage(page + 1) : () => {}}>
                  <span aria-hidden="true">&gt;</span>
                </Pagination.Next>
              </Pagination>
            )}
          </div>
        </Container>
      </main>
    </div>
  );
};

export default ApplicationsPage;